<div *ngIf="messages.length && !loading && !isServerError" class="messages">
  <div *ngFor="let message of messages" class="message-item">
    <div class="message-header">
      <div class="message-date">{{ message.date | date }}</div>

      <h4 class="message-title">
        <!-- <a *ngIf="message.nodeId" href="{{getMessageUrl(message.nodeId)}}" target="_blank">{{ message.title }}</a>
        <span *ngIf="!message.nodeId">{{ message.title }}</span> -->
        <span class="message-title-popup-action" message-node-id="message.nodeId" data-mfp-src="#main-popup" (click)="openPopup(message.nodeId, $event)">{{ message.title }}</span>
      </h4>
    </div>
    <div class="message-content">{{ message.description }}</div>
    <div *ngIf="message.unitName" class="message-unit-name">
      {{ message.unitName }}
    </div>
  </div>
</div>

<div *ngIf="loading && !isServerError" class="messages">
  <div *ngFor="let _ of [].constructor(3)"  class="message-item">
    <div class="message-header">
      <app-skeleton [type]="'text'" class="message-date" [symbolsCount]="10"></app-skeleton>
      <app-skeleton [type]="'text'" class="message-title" [symbolsCount]="20"></app-skeleton>
    </div>
    <app-skeleton [type]="'text'" class="message-content" [symbolsCount]="50"></app-skeleton>
  </div>
</div>


<div *ngIf="!messages.length && !loading && !isServerError">
  {{widgetData.noMessagesText}}
</div>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>